import { computed, observable } from 'mobx'

export default class MessagesStore {
  rootStore = null

  @observable accessor unreadCount = 10

  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @computed
  get hasUnreadMessages() {
    return this.unreadCount > 0
  }
}
